import React, { useState, useEffect, useRef } from 'react'; 
import backgroundImage from './tcborder.png';
import { useDispatch, useSelector } from 'react-redux';
import { readSchools } from '../../../store/actions/schoolActions';
import { fetchLogo  } from '../../../store/actions/logoActions';

const TransferCertificate = React.forwardRef((props, ref) => {

  const dispatch = useDispatch();
  const { schools, loading, error } = useSelector((state) => state.schoolDetails);
  const { logoUrl } = useSelector((state) => state.logo);
// const [schools, setSchools] = useState(null);

  useEffect(() => {
    dispatch(readSchools());
    dispatch(fetchLogo());
  }, [dispatch]);


  const Logo = logoUrl;

  const grades = ['N', 'KG', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'];
  const currentIndex = grades.indexOf(props.class_last_studied);

  const formatDate = (dateString) => {
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
  };

  const admission_date = formatDate(props.date_of_admission);
  const leaving_date = formatDate(props.date_of_leaving);
  const issue_date = formatDate(props.date_of_issue);
  const dob = formatDate(props.date_of_birth);

  const isMale = props.gender === 'male';
  const isPromoted = props.promotion_status === 'Promoted';
  
  const nextClass = props.promotion_status === 'Promoted' 
      ? (currentIndex >= 0 && currentIndex < grades.length - 1 ? grades[currentIndex + 1] : props.class_last_studied)
      : props.class_last_studied;

  const getNextClass = (currentClass) => {
    const currentIndex = grades.indexOf(currentClass);
    return currentIndex >= 0 && currentIndex < grades.length - 1 ? grades[currentIndex + 1] : currentClass;
  };

  const promotion_Exam = getNextClass(props.class_last_studied);
  const { conduct } = props;
  const displayConduct = conduct ? conduct : '______________________________';
    
  const reasonsForLeaving = [
    'Family Relocation',
    'Admission to Another School',
    'Financial Reasons',
    'Health Issues',
    'Completion of Course'
  ];

  return (
    <div 
      ref={ref} 
      style={{ 
        width: '240mm', 
        height: '297mm', 
        margin: '0 auto', 
        padding: '14mm',
        fontFamily: 'Arial, sans-serif',
        fontSize: '18px',
        position: 'relative',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        boxSizing: 'border-box',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {/* Watermark */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        opacity: 0.1, // Controls the transparency of the watermark
        zIndex: 0,
      }}>
        <img src={Logo} alt='Logo Watermark' style={{ width: '500px', height: '500px' }} />
      </div>

      {/* Content */}
      <div className='d-flex justify-content-between align-items-center' style={{marginTop:'50px', zIndex: 1, position: 'relative'}}>
        <div className='m-1'>
          <img src={Logo} alt='Logo' width='120' />
        </div>
        <div className="d-block justify-content-center align-items-center" style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          justifyContent: 'center', 
          textAlign: 'center' 
        }}>
          {schools.length > 0 ? (
              schools.map((school, index) => (
                <div key={index}>
                  <h2> {school.school_name} </h2>
                  <p style={{fontWeight: 'bold', color: '#000'}}>
                    {school.city}, {school.district}, {school.state}, {school.postal_code}
                    <br />
                  </p>
                </div>
              ))
            ) : (
              <>
                <h2>Name of School</h2>
                <p style={{fontWeight: 'bold', color: '#000'}}>
                  City, District, State - Pin code
                  <br />
                </p>
              </>
            )}

        </div>
        <div className='m-1'>
          <p>TC No: <strong style={{ color: 'red' }}>000{props.tc_number}</strong></p>
        </div>
      </div>
      <hr style={{ 
        border: '0', 
        height: '2px', 
        backgroundColor: '#000', 
        margin: '10px 0' 
      }} />
      <div className='d-flex justify-content-center'>
        <div style={{ border: '1px solid black', padding: '5px', display: 'inline-block', marginTop: '15px', marginBottom: '15px' }}>
          <h3 style={{ margin: '0' }}>Leaving/ Transfer Certificate</h3>
        </div>
      </div>
      <p className='p-2' style={{ zIndex: 1, position: 'relative' }}>
        This is to certify that {isMale ? 'Mr. ' : 'Miss '} <strong>{props.student_name}</strong>, {isMale ? 'son ' : 'daughter '} of Shri. <strong>{props.father_name}</strong> and Smt. <strong>{props.mother_name}</strong>, born on <strong>{dob}</strong>,
        was admitted to this school on <strong>{admission_date}</strong> and studied in class <strong>{props.class_last_studied === 'N'? 'Nursery':props.class_last_studied}</strong>. {isMale ? 'His ' : 'Her '} Permanent Education Number (PEN) is <strong>{props.pen}</strong>.
        {isMale ? ' He ' : ' She '} {isPromoted ? ' has passed ' : ' has not passed '} the examination for promotion to class <strong>{promotion_Exam}</strong> and was {props.promotion_status === 'Promoted' ? 'promoted to' : 'retained in'} class <strong>{nextClass}</strong>. 
        The student left the school on <strong>{leaving_date}</strong>.
        The conduct of the student has been <strong>{displayConduct}</strong> during {isMale ? ' his ' : ' her '} stay at this school with <strong>{props.remarks}</strong> remark.
      </p>
      <p style={{ textIndent: '50px', zIndex: 1, position: 'relative' }}>
        All sums due by {isMale ? ' him ' : ' her '} upto month have been paid.
      </p>
      <div className='d-flex justify-content-start mt-20 p-1' style={{ zIndex: 1, position: 'relative' }}>
        <span><strong>Reasons for leaving:</strong></span>
        <ol>
          {reasonsForLeaving.map((reason, index) => (
            <li key={index}>
              {reason}
              {props.reason_for_leaving === reason && ' ✓✓'}
            </li>
          ))}
        </ol>
      </div>
      <div className='d-flex justify-content-between mt-30 p-4' style={{ zIndex: 1, position: 'relative' }}>
        <h6 style={{marginTop: '60px'}}>Date of Issue: <strong>{issue_date}</strong></h6>
        <div className='d-block justify-content-center' style={{ textAlign: 'center', marginTop: '60px' }}>
          <h6>Signature with Seal</h6>
          <h6>Principal/ Head of Institution</h6>
        </div>
      </div>
    </div>
  );
});

export default TransferCertificate;

